import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { ResposeGeneric } from '../../../core/shared/respose-generic';
import { UtilityService } from '../../../core/shared/utility.service';


@Injectable()
export class StudentService {
  uriProgramsByStudent =  environment.urlServices + 'estudiantes/programas';
  uriInformatioStudentPrograms = environment.urlServices + 'estudiantes/programas-activos';
  uriStudentRecords = environment.urlServices + 'estudiantes/historial';
  uriStudentSemesters = environment.urlServices + 'estudiantes/semestres';

  constructor(private httpClient: HttpClient, private utilityService: UtilityService) { }

  getProgramsByStudent(cedula , programa): Observable<ResposeGeneric> {
       const parameters = { cedula : cedula};
       if (programa !==  null) {
         parameters['programa'] = programa;
       }
       return this.httpClient.get<ResposeGeneric>(
         this.utilityService.addQueryParam(this.uriProgramsByStudent, parameters));
  }

  getInformatioStudentPrograms(cedula , programa): Observable<ResposeGeneric> {
      const parameters = { cedula : cedula};
      if (programa !==  null) {
        parameters['programa'] = programa;
      }
      return this.httpClient.get<ResposeGeneric>(
        this.utilityService.addQueryParam(this.uriInformatioStudentPrograms, parameters)
      );
  }

  getStudentRecords(cedula, programa, findByProgram): Observable<ResposeGeneric> {
    const parameters = { cedula : cedula , programa : programa, buscarPrograma: findByProgram};
      return this.httpClient.get<ResposeGeneric>(
        this.utilityService.addQueryParam(this.uriStudentRecords, parameters)
      );
  }

  getStudentRSemesters(cedula): Observable<ResposeGeneric> {
    const parameters = { cedula : cedula };
      return this.httpClient.get<ResposeGeneric>(
        this.utilityService.addQueryParam(this.uriStudentSemesters, parameters)
      );
  }

}
